export const card = "rounded-2xl bg-white border border-[#5B6E5B]/10 shadow-[0_8px_32px_rgba(91,110,91,0.06)]";
export const input =
  "w-full rounded-xl bg-white border border-[#5B6E5B]/15 px-4 py-2.5 font-body text-sm text-[#2C332A] placeholder:text-[#A8B0A2] outline-none transition-[border-color,box-shadow] duration-300 focus:border-[#C87A5E] focus:ring-2 focus:ring-[#C87A5E]/25";
export const label = "font-body text-xs font-medium text-[#4A5D4E] mb-1.5 block";
export const btnPrimary =
  "inline-flex items-center justify-center gap-2 rounded-full bg-[#5B6E5B] px-5 py-2.5 text-sm text-[#FDFBF7] transition-[transform,background-color] duration-300 hover:bg-[#4A5D4E] hover:scale-[1.02] disabled:opacity-60";
export const btnGhost =
  "inline-flex items-center justify-center gap-2 rounded-full border border-[#5B6E5B]/20 bg-white px-4 py-2 text-sm text-[#4A5D4E] transition-colors duration-300 hover:bg-[#F5F0E6]";
export const h1 = "font-display text-3xl sm:text-4xl text-[#2C332A]";
export const badge = (ok) =>
  `inline-flex items-center rounded-full px-3 py-1 text-xs font-body ${ok ? "bg-[#5B6E5B]/12 text-[#4A5D4E]" : "bg-[#C87A5E]/15 text-[#B2644D]"}`;

export const currency = (v) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(v || 0));

export const fmtDate = (d) => {
  try {
    const [y, m, day] = d.split("-");
    return `${day}/${m}/${y}`;
  } catch {
    return d;
  }
};

export const waLink = (phone, text = "") => {
  const digits = String(phone || "").replace(/\D/g, "");
  if (!digits) return null;
  const full = digits.startsWith("55") || digits.length > 11 ? digits : `55${digits}`;
  return `https://wa.me/${full}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
};

// Regra de atraso: sessão de 50 min com tolerância de 20 min; o término NUNCA prorroga.
// Retorna "em_tolerancia" | "excedida" | null — apenas sinaliza; a ausência é confirmada manualmente.
export const lateness = (s) => {
  if (!s?.date || !s?.time || s.status !== "agendada") return null;
  const start = new Date(`${s.date}T${s.time}:00`);
  if (isNaN(start)) return null;
  const diffMin = (Date.now() - start.getTime()) / 60000;
  if (diffMin < 0 || diffMin > (s.duration_min || 50)) return null;
  return diffMin > 20 ? "excedida" : "em_tolerancia";
};
